var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[[_c('ul',{staticClass:"rating-box"},_vm._l((_vm.rate),function(index){return _c('li',{key:index,staticClass:"rate"},[(index > _vm.level)?_c('img',{attrs:{"src":"img/icons/empty-gem.png"}}):_vm._e(),(index <= _vm.level)?_c('img',{attrs:{"src":"img/icons/gem.png"}}):_vm._e()])}),0)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }